// extracted by mini-css-extract-plugin
export default {"main__cont":"analitics_main__cont__hrMKF","button_down":"analitics_button_down__TpgXv","selobj":"analitics_selobj__8-Slw"};